// src/axios.js
import axios from 'axios';
import router from './router';
import Vue from 'vue';

const vuesaxInstance = new Vue();
const apiBaseURL = process.env.VUE_APP_API_URL || 'https://backend.harmony.fan/api';

const instance = axios.create({
    baseURL: apiBaseURL,
});

// Interceptor para añadir el token de autorización en cada petición
instance.interceptors.request.use(config => {
    // localStorage puede lanzar SecurityError en webviews in-app / modo privado.
    // Si falla, la petición debe continuar sin token (las rutas públicas no lo necesitan).
    let token = null;
    try {
        token = localStorage.getItem('token');
    } catch (e) {
        token = null;
    }
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

// Interceptor para manejar errores de respuesta
instance.interceptors.response.use(response => {
    return response;
}, error => {
    // error.response puede ser undefined en fallos de red/timeout
    const status = error && error.response ? error.response.status : null;

    const clearSession = () => {
        try {
            localStorage.removeItem('user');
            localStorage.removeItem('token');
        } catch (e) {
            // Storage bloqueado en webview in-app / modo privado
        }
    };

    if (status === 401) {
        clearSession();
        //window.location.href = "/";
        try {
            vuesaxInstance.$vs.notify({
                title: "Error de conexión",
                text: "No se pudo recuperar la sesión.",
                color: 'danger',
                icon: 'warning',
                position: 'bottom-center',
                time: 5000,
            });
        } catch (e) { /* notificaciones no disponibles */ }

        if (router.currentRoute.path !== '/') {
            router.push('/');
        } else {
            window.location.reload();
        }

    } else if (status === 403) {
        clearSession();
        if (router.currentRoute.path !== '/') {
            try {
                vuesaxInstance.$vs.notify({
                    title: "Acceso denegado",
                    text: "No tiene permisos para acceder a este recurso.",
                    color: 'danger',
                    icon: 'warning',
                    position: 'bottom-center',
                    time: 5000,
                });
            } catch (e) { /* notificaciones no disponibles */ }
            router.push('/');
        }
    }

    return Promise.reject(error);
});


export default instance;
